import { SvgIcon, SvgIconProps } from "@mui/material";

export const UserAdminIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24" fill="none">
    <path
      d="M16.7398 19.59H7.26978C6.47978 19.59 5.90977 19.56 5.41977 19.49C1.94977 19.11 1.25977 17.03 1.25977 13.58V7.26001C1.25977 3.81001 1.93977 1.72998 5.43977 1.34998C5.91977 1.27998 6.48978 1.25 7.26978 1.25H16.7398C17.5198 1.25 18.0898 1.27998 18.5898 1.34998C22.0698 1.72998 22.7498 3.81001 22.7498 7.26001V13.58C22.7498 17.03 22.0698 19.11 18.5698 19.49C18.0998 19.56 17.5298 19.59 16.7398 19.59ZM7.25977 2.75C6.54977 2.75 6.03977 2.78003 5.61977 2.84003C3.45977 3.08003 2.74977 3.75002 2.74977 7.27002V13.59C2.74977 17.1 3.45978 17.78 5.59978 18.01C6.03978 18.07 6.54978 18.1 7.26978 18.1H16.7398C17.4598 18.1 17.9598 18.07 18.3798 18.01C20.5398 17.77 21.2498 17.1 21.2498 13.58V7.26001C21.2498 3.75001 20.5398 3.07003 18.3998 2.84003C17.9498 2.78003 17.4498 2.75 16.7298 2.75H7.25977Z"
      fill="currentColor"
    />
    <path
      d="M17.2601 9.07031H13.5801C13.1701 9.07031 12.8301 8.73031 12.8301 8.32031C12.8301 7.91031 13.1701 7.57031 13.5801 7.57031H17.2601C17.6701 7.57031 18.0101 7.91031 18.0101 8.32031C18.0101 8.73031 17.6801 9.07031 17.2601 9.07031Z"
      fill="currentColor"
    />
    <path
      d="M10 9.32031C9.45 9.32031 9 8.87031 9 8.32031C9 7.77031 9.44 7.32031 10 7.32031C10.55 7.32031 11 7.77031 11 8.32031C11 8.87031 10.56 9.32031 10 9.32031Z"
      fill="currentColor"
    />
    <path
      d="M6.8501 9.32031C6.3001 9.32031 5.8501 8.87031 5.8501 8.32031C5.8501 7.77031 6.2901 7.32031 6.8501 7.32031H6.86009C7.41009 7.32031 7.86009 7.77031 7.86009 8.32031C7.86009 8.87031 7.4001 9.32031 6.8501 9.32031Z"
      fill="currentColor"
    />
    <path
      d="M17.2602 14.8599H6.75023C6.34023 14.8599 5.99023 14.5199 5.99023 14.1099C5.99023 13.6999 6.32022 13.3599 6.73022 13.3599H17.2602C17.6702 13.3599 18.0102 13.6999 18.0102 14.1099C18.0102 14.5199 17.6802 14.8599 17.2602 14.8599Z"
      fill="currentColor"
    />
    <path
      d="M17 22.75H7C6.59 22.75 6.25 22.41 6.25 22C6.25 21.59 6.59 21.25 7 21.25H17C17.41 21.25 17.75 21.59 17.75 22C17.75 22.41 17.41 22.75 17 22.75Z"
      fill="currentColor"
    />
  </SvgIcon>
);
